import React from "react";

import Navbar from "./components/navbar";
import CreateKioskoComponent from "./create/create.component";
import CreateKioskoProvider from "./create/provider/createKiosko.provider";
import CreateUsedKioskoProvider from "./create/provider/createUsedKiosko.provider";
import CreateNewsKioskoProvider from "./create/provider/createNewsKiosko.provider";
import {
  IKioskoConfig,
  KioskoConfigProvider,
} from "./context/kiosko-config.context";

interface IProps {
  config: IKioskoConfig;
}

const KioskoPage = ({ config }: IProps) => {
  return (
    <KioskoConfigProvider config={config}>
      <CreateKioskoProvider>
        <CreateNewsKioskoProvider>
          <CreateUsedKioskoProvider>
            <div
              className="h-screen overflow-auto"
              style={{
                background: `linear-gradient(to bottom, ${config.bgGradientColorPrimary}, ${config.bgGradientColorSecondary})`,
              }}
            >
              <Navbar />
              <section className="flex h-full w-full items-center justify-center p-0 pt-24">
                <div className="container mb-auto mt-auto w-full px-4 lg:px-20">
                  <CreateKioskoComponent />
                </div>
              </section>
            </div>
          </CreateUsedKioskoProvider>
        </CreateNewsKioskoProvider>
      </CreateKioskoProvider>
    </KioskoConfigProvider>
  );
};

export default KioskoPage;
